import React, { useState } from "react"

import { buildQuery, compress, useQuery } from "micro-graphql-react"

import Pagination from "components/Pagination"
import WithLoadingIndicator from "components/WithLoadingIndicator"

import StudyGroup from "./StudyGroup"
import studyGroupFragment from "./studyGroupFragment"

const AssignedStudyGroups = ({ courseSection }) => {
  const [page, setPage] = useState(1)
  const loadingState = useQuery(
    buildQuery(
      groupsQuery,
      { courseSectionId: courseSection.id, page: page },
      {
        onMutation: [
          {
            when: "courseSectionRegisterStudent",
            run: ({ softReset, currentResults }, response) => {
              const { courseSection: updatedCourseSection } =
                response.courseSectionRegisterStudent
              if (updatedCourseSection?.id !== courseSection.id) return

              currentResults.courseSection.assignedStudyGroups =
                updatedCourseSection.assignedStudyGroups
              softReset(currentResults)
            },
          },
          {
            when: "courseSectionBulkRegisterStudents",
            run: ({ softReset, currentResults }, response) => {
              const { courseSection: updatedCourseSection } =
                response.courseSectionBulkRegisterStudents
              if (updatedCourseSection?.id !== courseSection.id) return

              currentResults.courseSection.assignedStudyGroups =
                updatedCourseSection.assignedStudyGroups
              softReset(currentResults)
            },
          },
          {
            when: "courseSectionChangeTutor",
            run: ({ softReset, currentResults }, response) => {
              const { studyGroup } = response.courseSectionChangeTutor
              if (studyGroup?.courseSection?.id !== courseSection.id) return

              const updatedGroupIndex =
                currentResults.courseSection.assignedStudyGroups.data.findIndex(
                  g => g.id === studyGroup.id
                )
              currentResults.courseSection.assignedStudyGroups.data[
                updatedGroupIndex
              ].tutor = studyGroup.tutor
              softReset(currentResults)
            },
          },
        ],
      }
    )
  )

  return (
    <WithLoadingIndicator
      loadingState={loadingState}
      heading={<h4>Assigned Study Groups</h4>}
    >
      {({ data }) =>
        data.courseSection.assignedStudyGroups.data.length > 0 ? (
          <>
            {data.courseSection.assignedStudyGroups.data.map(group => (
              <StudyGroup studyGroup={group} key={group.id} canChangeTutor />
            ))}
            <Pagination
              currentPage={data.courseSection.assignedStudyGroups.currentPage}
              totalPages={data.courseSection.assignedStudyGroups.totalPages}
              changePage={setPage}
            />
          </>
        ) : (
          <div>
            <span>No assigned groups</span>
            <hr />
          </div>
        )
      }
    </WithLoadingIndicator>
  )
}

const groupsQuery = compress`
  ${studyGroupFragment}
  query($courseSectionId: ID!, $page: Int) {
    courseSection(id: $courseSectionId) {
      assignedStudyGroups(page: $page) {
        currentPage
        totalPages
        data {
          ...StudyGroupFields
        }
      }
    }
  }
`

export default AssignedStudyGroups
